import { useMemo } from 'react';
import { UserRole, BookingPermissions } from '@shared/types/booking';

export function useBookingPermissions(userRole: UserRole): BookingPermissions {
  return useMemo(() => {
    switch (userRole) {
      case 'customer':
        return {
          canCreate: true,
          canView: true,
          canEdit: false,
          canCancel: true,
          canExport: false,
          canViewAll: false,
          canViewCustomerDetails: false
        };
      
      case 'staff':
        return {
          canCreate: true,
          canView: true,
          canEdit: true,
          canCancel: true,
          canExport: false,
          canViewAll: true,
          canViewCustomerDetails: true
        };
      
      case 'admin':
        return {
          canCreate: true,
          canView: true,
          canEdit: true,
          canCancel: true,
          canExport: true,
          canViewAll: true,
          canViewCustomerDetails: true
        };
      
      default:
        return {
          canCreate: false,
          canView: false,
          canEdit: false,
          canCancel: false,
          canExport: false,
          canViewAll: false,
          canViewCustomerDetails: false
        };
    }
  }, [userRole]);
}
